import { connect } from 'react-redux';
import AdminHomepage from '../components/admin_homepage';
import actions from '../redux/actions';

function mapStateToProps(state: any) {
    const { user } = state.user;
    const { layoutTitles } = state.samaritan;

    return {
        user,
        layoutTitles
    };
}

const mapDispatchToProps = {
    setLayoutTitles: actions.setLayoutTitles,
    resetCatchUpItemStatus: actions.resetCatchUpItemStatus,
    resetHomelessInfo: actions.resetHomelessInfo,
    resetMessageInfo: actions.resetMessageInfo,
    resetMemberReferrals: actions.resetMemberReferrals,
    resetTouchpointAnswers: actions.resetTouchpointAnswers,
    resetUnenrollmentState: actions.resetUnenrollmentState
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminHomepage);